const apiUrl = process.env.REACT_APP_API_URL;

interface Response {
    ok: boolean;
    data?: string;
    error?: string;
}

export const PostGenerateAvatar = async (userId: string, prompt: string): Promise<Response> => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/avatar/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId, prompt }),
        });

        if (response.ok) {
            let text = await response.text();
            if (text && text.startsWith('/jutge')) {
                text = `${apiUrl}:8061${text}`;
            }
            return { ok: true, data: text };
        } else {
            const errorText = await response.text();
            return { ok: false, error: errorText || 'Error generating avatar' };
        }
    } catch (error) {
        return { ok: false, error: 'Network error' };
    }
};
